import { Action, SimpleSelect } from 'corso-admin-ui';
import { Pegasus } from 'corso-types';
import { Controller } from 'react-hook-form';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import useFulfillmentLocations from '~/features/settings/automations/hooks/useFulfillmentLocations';
import {
  restockProviderActionLabel,
  shopifyRestockNameLabel,
} from '~/utils/enumNameMaps';

export default function EventRestockInventory() {
  const { control, watch } = useAutomationFormContext();
  const { data: fulfillmentLocations = [] } = useFulfillmentLocations();
  const shopifyRestockLocationOptions = fulfillmentLocations.map(
    (location) => ({
      label: location.name,
      value: location.idFromPlatform,
    }),
  );

  // TODO: At a later date allow Xoro to be added based on a configured ERP connection
  const restockProviderOptions = Object.values(Pegasus.RestockPlatform)
    .map((provider) => ({
      label: restockProviderActionLabel[provider],
      value: provider,
    }))
    .filter((provider) => provider.value !== Pegasus.RestockPlatform.XORO);

  const platformWatch = watch('event.params.restockPlatform');
  const inventoryStateWatch = watch('event.params.shopifyRestockName');

  const shopifyRestockNameOptions = Object.values(Pegasus.RestockName).map(
    (action) => ({
      label: (
        <div className="flex flex-col items-start gap-1">
          <p>{shopifyRestockNameLabel[action].label}</p>
          <p className="text-xs text-neutral-500">
            {shopifyRestockNameLabel[action].details}
          </p>
        </div>
      ),

      value: action,
    }),
  );

  return (
    <div className="flex flex-col gap-4">
      <Controller
        control={control}
        name="event.params.restockPlatform"
        render={({ field }) => (
          <SimpleSelect
            label="Platform"
            details="The platform to restock the inventory to."
            options={restockProviderOptions}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />

      {platformWatch === Pegasus.RestockPlatform.SHOPIFY && (
        <>
          <Controller
            control={control}
            name="event.params.shopifyRestockName"
            render={({ field }) => (
              <SimpleSelect
                label="Inventory State"
                details={
                  <p>
                    The name of the inventory state to restock inventory to.
                    Learn more{' '}
                    <Action
                      to="https://help.shopify.com/en/manual/products/inventory/managing-inventory-quantities/inventory-states"
                      target="_blank"
                      variant="link"
                      className="text-xs"
                    >
                      here.
                    </Action>
                  </p>
                }
                options={shopifyRestockNameOptions}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />

          {inventoryStateWatch !== Pegasus.RestockName.none && (
            <Controller
              control={control}
              name="event.params.restockLocationIdFromPlatform"
              render={({ field }) => (
                <SimpleSelect
                  options={shopifyRestockLocationOptions}
                  value={field.value ?? ''}
                  onChange={field.onChange}
                  label="Restock Location"
                  placeholder="Select a Location"
                  details="If no location is provided, the location that fulfilled the order will be used."
                />
              )}
            />
          )}
        </>
      )}
    </div>
  );
}
